import axios from "axios";
import { Button, Form, Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import useAuth from "../../hooks/useAuth";
import { Base_URL } from "../../helpers/constants";

function AddUsermodal({ open, onClose, vendorId, userLanguages }) {
  const { auth } = useAuth();
  if (!open) return null;

  const token = auth.accessToken;

  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

  const schema = yup.object().shape({
    typeSelect: yup.string(),
    userEmail: yup.string().email("Polje mora biti e-naslov"),
    apiEmail: yup.string().email("Polje mora biti e-naslov"),
    firstName: yup.string(),
    lastName: yup.string(),
    languages: yup.string(),
    vendorId: yup.string(),
  });

  return (
    <div>
      <Modal show={open} onHide={onClose} role="dialog">
        <Formik
          validationSchema={schema}
          onSubmit={(values) => {
            if (values.typeSelect === "APPLICATION") {
              (values.firstName = "API") &&
                (values.lastName = "Access") &&
                (values.userEmail = values.apiEmail);
              axios({
                method: "POST",
                url: `${Base_URL}createAPI`,
                data: values,
              })
                .then(function (res) {
                  alert("Successfully addeed API User!");
                  onClose();
                })
                .catch(function (res) {
                  console.log(res);
                });
            }
            if (values.typeSelect === "USER") {
              axios({
                method: "POST",
                url: `${Base_URL}createUser`,
                data: values,
              })
                .then(function (res) {
                  console.log(res);
                  alert("Successfully addeed User!");
                  onClose();
                })
                .catch(function (res) {
                  console.log(res);
                });
            }
          }}
          initialValues={{
            typeSelect: "USER",
            userEmail: "",
            apiEmail: "",
            firstName: "",
            lastName: "",
            languages: userLanguages[0] || "SL",
            vendorId: vendorId,
          }}
        >
          {({ handleSubmit, handleChange, values, touched, errors }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Modal.Header>
                <Modal.Title>Dodajanje uporabnika</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group>
                  <Form.Label htmlFor="typeSelect">Tip Uporabnika</Form.Label>
                  <Form.Select
                    type="select"
                    name="typeSelect"
                    id="typeSelect"
                    onChange={handleChange}
                    value={values.typeSelect}
                    isValid={touched.typeSelect && !errors.typeSelect}
                    isInvalid={!!errors.typeSelect}
                  >
                    <option value="USER" label="Uporabnik" />
                    <option value="APPLICATION" label="API dostop" />
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.typeSelect}
                  </Form.Control.Feedback>
                </Form.Group>
                {values.typeSelect === "USER" && (
                  <div>
                    <Form.Group>
                      <Form.Label htmlFor="userEmail">
                        Kontaktni e-naslov
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="userEmail"
                        id="userEmail"
                        placeholder="ime@podjetje.si"
                        onChange={handleChange}
                        isValid={touched.userEmail && !errors.userEmail}
                        isInvalid={!!errors.userEmail}
                        value={values.userEmail}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.userEmail}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label htmlFor="nameForm">Ime</Form.Label>
                      <Form.Control
                        name="firstName"
                        id="firstName"
                        placeholder="Vnesi ime uporabnika"
                        onChange={handleChange}
                        isValid={touched.firstName && !errors.firstName}
                        isInvalid={!!errors.firstName}
                        value={values.firstName}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.firstName}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label htmlFor="surnameForm">Priimek</Form.Label>
                      <Form.Control
                        name="lastName"
                        id="lastName"
                        placeholder="Vnesi priimek uporabnika"
                        onChange={handleChange}
                        isValid={touched.lastName && !errors.lastName}
                        isInvalid={!!errors.lastName}
                        value={values.lastName}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.lastName}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label htmlFor="languageForm">Jezik</Form.Label>
                      <Form.Select
                        type="languages"
                        name="languages"
                        id="languages"
                        onChange={(e) => {
                          handleChange(e);
                          console.log("Language changed to:", e.target.value);
                        }}
                        value={values.languages}
                        isValid={touched.languages && !errors.languages}
                        isInvalid={!!errors.languages}
                      >
                        {userLanguages.map((lang, index) => (
                          <option key={index} value={lang} label={lang} />
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.languages}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                )}
                {values.typeSelect === "APPLICATION" && (
                  <>
                    <Form.Group>
                      <Form.Label htmlFor="apiEmailInput">
                        Uporabniško ime (e-naslov)
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="apiEmail"
                        id="apiEmailInput"
                        placeholder="ime@podjetje.si"
                        onChange={handleChange}
                        isValid={touched.apiEmail && !errors.apiEmail}
                        isInvalid={!!errors.apiEmail}
                        value={values.apiEmail}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.apiEmail}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label htmlFor="languageForm">
                        Jezik (SL ali EN)
                      </Form.Label>

                      <Form.Select
                        type="languages"
                        name="languages"
                        id="languages"
                        onChange={handleChange}
                        value={values.languages}
                        isValid={touched.languages && !errors.languages}
                        isInvalid={!!errors.languages}
                      >
                        <option value="SL" label="SL" />
                        <option value="EN" label="EN" />
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.languages}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button type="submit">Dodaj</Button>{" "}
                <Button type="button" variant="secondary" onClick={onClose}>
                  Prekliči
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
}

export default AddUsermodal;
